import { render, staticRenderFns } from "./RelatorioLista.vue?vue&type=template&id=2698a9f0&scoped=true&lang=html&"
import script from "./RelatorioLista.vue?vue&type=script&lang=js&"
export * from "./RelatorioLista.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioLista.vue?vue&type=style&index=0&id=2698a9f0&scoped=true&lang=css&"
import style1 from "./RelatorioLista.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2698a9f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem,VTabs})
